import React from 'react'

const NoDataComponent = ({ data , subtitle,children}) => {
    return (
        <div style={{ width: '100%', height: 500, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            No {data}
            <br />
            {children}
        </div>
    )
}

export default NoDataComponent
